<template>
  <main :class="ns.b()">
    <slot />
  </main>
</template>
<script lang="ts" setup>
import { useNamespace } from '@jdesign-vue/hooks'

defineOptions({
  name: 'JdMain',
})

const ns = useNamespace('main')
</script>
